import React, { useEffect, useState } from 'react';

import SatModal from '@components/common/satUI/SatModal';
import { useDispatch, useSelector } from 'react-redux';
import { retrieveLossInsuranceBeforeTheFactListSelect } from '@store/actions/planAction';
import { isCoveredCustomer } from '@components/simulation/Common';
import SatDatePicker from '@components/common/satUI/SatDatePicker';
import { getToday } from '@common/utils/date';

const LossInsuranceBeforeTheFactListSelectPopup = props => {
  const { visible, setVisible, lossInsuranceBeforeTheFactList = [] } = props;
  const { customerList } = useSelector(state => state.planReducer);
  const { userInfo } = useSelector(state => state.userReducer);
  const dispatch = useDispatch();
  const [selDd, setSelDd] = useState(getToday());

  // 조회
  const searchInfo = () => {
    const coveredPerson = customerList.find(
      customer => customer.custNo && isCoveredCustomer(customer),
    );
    const payload = {
      prspCustNo: coveredPerson.custNo,
      wlpEmpNo: userInfo.empno || userInfo.userId,
      selDd: selDd?.replace(/\D/g, ''),
    };
    dispatch(retrieveLossInsuranceBeforeTheFactListSelect(payload));
  };

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        searchInfo();
      }, [500]);
    }
  }, [visible]);

  return (
    <SatModal visible={visible} setVisible={setVisible} type={'fullPop'}>
      <>
        <header className="con-header">
          <div className="page-navi">
            <button
              type="button"
              className="btn-back"
              onClick={() => setVisible(false)}
            >
              이전
            </button>
          </div>
          <h1 className="page-tit">실손보상계약사전조회</h1>
        </header>
        <div className="con-wrap">
          <div className="cont">
            <div
              style={{
                display: 'flex',
                marginTop: '10px',
                marginBottom: '10px',
              }}
            >
              <span
                className="data-tit"
                style={{
                  marginTop: '10px',
                  marginRight: '10px',
                }}
              >
                조회일자
              </span>
              <SatDatePicker
                withPortal={false}
                value={selDd}
                size={'small'}
                onChange={value => setSelDd(value)}
                noDisableCss={true}
              />
              <button
                className="btn-s blue"
                onClick={searchInfo}
                style={{
                  marginTop: '5px',
                  marginLeft: '10px',
                }}
              >
                <span>조회</span>
              </button>
            </div>
            <div className="modal-scroll-wrap2">
              <table className="tbl-sty5 text-center">
                <colgroup>
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                </colgroup>
                <thead>
                  <tr>
                    <th>순번</th>
                    <th>동의방법</th>
                    <th>동의일자</th>
                    <th>회사명</th>
                    <th>증권번호</th>
                    <th>보험상품명</th>
                    <th>실손보장내용</th>
                    <th>실손담보특성</th>
                    <th>실손담보시작일자</th>
                    <th>실손담보종료일자</th>
                    <th>실손담보상태</th>
                    <th>가입금액</th>
                    <th>실손본인부담</th>
                  </tr>
                </thead>
                <tbody>
                  {lossInsuranceBeforeTheFactList.length > 0 ? (
                    lossInsuranceBeforeTheFactList.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item.seq}</td>
                          <td>{item.agreeMethod}</td>
                          <td>{item.agreeDate}</td>
                          <td>{item.companyName}</td>
                          <td>{item.policyNo}</td>
                          <td>{item.productName}</td>
                          <td>{item.coverageDetail}</td>
                          <td>{item.guaranteeTrait}</td>
                          <td>{item.startDate}</td>
                          <td>{item.endDate}</td>
                          <td>{item.guaranteeStatus}</td>
                          <td>{item.faceAmount}</td>
                          <td>{item.ownBurden}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={13} className="nodata">
                        {'검색된 결과가 없습니다.'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </>
      {/*<div className="layer-footer">*/}
      {/*  <SatButton*/}
      {/*    label={'닫기'}*/}
      {/*    styleClass={'btn-s blue btn-wide'}*/}
      {/*    onClick={() => setVisible(false)}*/}
      {/*  />*/}
      {/*</div>*/}
    </SatModal>
  );
};

export default React.memo(LossInsuranceBeforeTheFactListSelectPopup);
